<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">Dashboard</router-link>
            <router-link to="/school/library-management" class="text-white">
                <i class="fa fa-ellipsis-v mx-2"></i>Library Management
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v mx-2"></i>Books</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <modal :show.sync="modals.bookModal" modal-classes="modal-dialog-centered">
                        <div class="card border-0 mb-0">
                            <div class="card-body">
                                <PageSpinner :onloader="onloader" />
                                <div class="form-horizontal">
                                    <form role="form" @submit.prevent="SubmitBookForm">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Enter Book No.</label>
                                                    <input v-model="BookNoval" placeholder="Enter Book No."
                                                        class="form-control" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Enter Title</label>
                                                    <input v-model="BookTitleval" placeholder="Enter Title"
                                                        class="form-control" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Enter Book Author</label>
                                                    <input v-model="BookAuthorval" placeholder="Enter Book Author"
                                                        class="form-control" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Enter Publisher Name</label>
                                                    <input v-model="BookPublisherval" placeholder="Enter Publisher Name"
                                                        class="form-control" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Enter ISBN No.</label>
                                                    <input v-model="BookIBNNoval" placeholder="Enter ISBN No."
                                                        class="form-control" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Enter Book Edition</label>
                                                    <input v-model="BookEditionval" placeholder="Enter Book Edition"
                                                        class="form-control" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Enter Shelf No.</label>
                                                    <input v-model="ShelfNoval" placeholder="Enter Shelf No."
                                                        class="form-control" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Select Book Category</label>
                                                    <select v-model="BookCategoryIdval" class="form-control">
                                                        <option value="0">- Select Category -</option>
                                                        <option v-for="item in LibraryCategoryItems" :key="item.Id"
                                                            v-bind:value="item.Id">
                                                            {{ item.CategoryName }}
                                                        </option>
                                                    </select>
                                                    <button class="btn btn-secondary btn-sm"
                                                        @click.prevent="openBookCategoryForm()">Add New
                                                        Category</button>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <img v-if="uploadedimage" height="100" :src="uploadedimage" />
                                                    <img v-else height="100" src="/img/brand/empty.png" />
                                                    <input type="file" id="file" ref="file" class="form-control"
                                                        v-on:change="handleFileUpload()" />
                                                    <br />
                                                    <button class="btn btn-outline-dark" @click.prevent="submitFile()">
                                                        <i class="fa fa-upload"></i>Upload
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-right">
                            <base-button type="default" @click="modals.bookModal = false">Cancel
                            </base-button>
                            <base-button type="success" @click.prevent="SubmitBookForm()">Submit
                            </base-button>
                        </div>
                    </modal>
                    <modal :show.sync="modals.bookCategoryModal" modal-classes="modal-dialog-centered">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <div class="card border-0 mb-0">
                                    <div class="card-body">
                                        <PageSpinner :onloader="onloader" />
                                        <div class="form-horizontal">
                                            <form role="form">
                                                <div class="form-group">
                                                    <label>Category Name</label>
                                                    <input v-model="CategoryNameval" placeholder="Enter Category Name" class="form-control" required />
                                                </div>
                                                <div class="form-group">
                                                    <label>Category Code</label>
                                                    <input v-model="CategoryCodeval" placeholder="Enter Category Code" class="form-control" required />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer text-center">
                                    <base-button type="default" @click="modals.bookCategoryModal = false">Cancel
                                    </base-button>
                                    <base-button type="success" @click.prevent="submitBookCategoryForm()">Submit
                                    </base-button>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <div class="justify-content-end form-inline mt-3">
                                    <base-input class="input-group-alternative" placeholder="Search here..."
                                        addon-left-icon="fa fa-search" v-model="searchval">
                                    </base-input>
                                </div>
                                <div class="table-responsive mt-2">
                                    <table class="table table-bordered table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Category Name</th>
                                                <th>Category Code</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in searchedBookCategoryResultQuery" :key="item.Id">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ item.CategoryName }}</td>
                                                <td>{{ item.CategoryCode }}</td>
                                                <td>
                                                    <button class="btn btn-secondary btn-sm"
                                                        v-on:click="editBookCategoryItem(item)">
                                                        <i class="fa fa-edit"></i> Edit
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </modal>
                    <div>
                        <div class="justify-content-end form-inline mt-3">
                            <button type="button" @click.prevent="OpenNewForm" class="btn btn-default">
                                <i class="fa fa-plus"></i>Add New
                            </button>
                            <base-input class="input-group-alternative" placeholder="Search here..."
                                addon-left-icon="fa fa-search" v-model="searchBookVal">
                            </base-input>
                        </div>
                        <div class="table-responsive mt-2">
                            <table class="table table-bordered table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Book No</th>
                                        <th>Book Title</th>
                                        <th>Book Publisher</th>
                                        <th>Category</th>
                                        <th>ISBN No</th>
                                        <th>Author</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in searchedBookResultQuery" :key="item.Id">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ item.BookNo }}</td>
                                        <td>{{ item.BookTitle }}</td>
                                        <td>{{ item.BookPublisher }}</td>
                                        <td>{{ item.CategoryName }}</td>
                                        <td>{{ item.BookISBNNo }}</td>
                                        <td>{{ item.BookAuthor }}</td>
                                        <td>
                                            <button class="btn btn-secondary btn-sm" v-on:click="editBootkItem(item)">
                                                <i class="fa fa-edit"></i> Edit
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </card>
            </div>
            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import LibraryCategoryMixin from "@/mixins/LibraryCategory.mixin"
import LibraryBookMixin from "@/mixins/LibraryBook.mixin"
import PageSpinner from "@/components/PageSpinner"
export default {
    name: "LibraryBook",
    mixins: [LibraryCategoryMixin, LibraryBookMixin, Alert],
    components: {
        PageSpinner
    },
    data() {
        return {
            accessDetails: null,
            Idval: 0,
            BookIBNNoval: "",
            BookNoval: "",
            BookTitleval: "",
            BookAuthorval: "",
            BookEditionval: "",
            BookCategoryIdval: 0,
            BookPublisherval: "",
            ShelfNoval: "",
            CategoryNameval: '',
            CategoryCodeval: '',
            searchval: '',
            ImagePathval: null,
            searchBookVal: "",
            LibraryCategoryItems: null,
            LibraryBookItems: null,
            file: "",
            uploadedimage: "",
            process: "N",
            onloader: "none",
            modals: {
                bookModal: false,
                bookCategoryModal: false
            }
        };
    },
    computed: {
        searchedBookResultQuery() {
            if (this.searchBookVal) {
                return this.LibraryBookItems.filter(item => {
                    return this.searchBookVal
                        .toLowerCase()
                        .split(" ")
                        .every(
                            v =>
                                item.BookNo.toLowerCase().includes(v) ||
                                item.BookISBNNo.toLowerCase().includes(v) ||
                                item.BookTitle.toLowerCase().includes(v) ||
                                item.BookAuthor.toLowerCase().includes(v) ||
                                item.BookPublisher.toLowerCase().includes(v) ||
                                item.CategoryName.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.LibraryBookItems;
            }
        },
        searchedBookCategoryResultQuery() {
            if (this.searchval) {
                return this.LibraryCategoryItems.filter(item => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            v =>
                                item.CategoryName.toLowerCase().includes(v) ||
                                item.CategoryCode.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.LibraryCategoryItems;
            }
        }
    },
    methods: {
        OpenNewForm() {
            this.ImgPathval = "";
            this.BookIBNNoval = "";
            this.BookNoval = "";
            this.BookTitleval = "";
            this.BookAuthorval = "";
            this.BookEditionval = "";
            this.BookCategoryIdval = 0;
            this.BookPublisherval = "";
            this.ShelfNoval = "";
            this.file = "";
            this.uploadedimage = "";
            this.modals.bookModal = true;
            this.process = "N";
            this.inputdisable = false;
        },
        openBookCategoryForm() {
            this.CategoryNameval = "";
            this.CategoryCodeval = "";
            this.modals.bookCategoryModal = true;
            this.process = "N";
        },
        editBootkItem(item) {
            this.onloader = "flex";
            this.Idval = item.Id;
            this.BookIBNNoval = item.BookISBNNo;
            this.BookNoval = item.BookNo;
            this.BookTitleval = item.BookTitle;
            this.BookAuthorval = item.BookAuthor;
            this.BookEditionval = item.BookEdition;
            this.BookCategoryIdval = item.BookCategoryId;
            this.BookPublisherval = item.BookPublisher;
            this.ShelfNoval = item.ShelfNo;
            if (item.ImagePath != null) {
                this.uploadedimage =
                    item.ImagePath;
            }
            this.ImagePathval = item.ImagePath;
            this.process = "U";
            this.onloader = "none";
            this.modals.bookModal = true;
        },
        SubmitBookForm() {
            let Id = this.Idval;
            let BookIBNNo = this.BookIBNNoval;
            let BookNo = this.BookNoval;
            let BookTitle = this.BookTitleval;
            let BookAuthor = this.BookAuthorval;
            let BookEdition = this.BookEditionval;
            let BookCategoryId = this.BookCategoryIdval;
            let BookPublisher = this.BookPublisherval;
            let ShelfNo = this.ShelfNoval;
            let ImagePath = this.ImagePathval;
            let processop = this.process;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let userdata = {
                Id,
                BookIBNNo,
                BookNo,
                BookTitle,
                BookAuthor,
                BookEdition,
                BookCategoryId,
                BookPublisher,
                ShelfNo,
                ImagePath,
                processop,
                username,
                accesskey
            };
            this.onloader = "flex";
            this.$store
                .dispatch("libraryBook/ProcessLibraryBook", userdata)
                .then(resp => {
                    this.LibraryBookItems = resp;
                    this.BookIBNNoval = "";
                    this.BookNoval = "";
                    this.BookTitleval = "";
                    this.BookAuthorval = "";
                    this.BookEditionval = "";
                    this.BookCategoryIdval = "";
                    this.BookPublisherval = "";
                    this.ShelfNoval = "";
                    this.ImagePathval = "";
                    this.process = "N";
                    this.onloader = "none";
                    this.ShowAlertSuccess('Submitted Successfully', '');
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
        },
        submitFile() {
            this.onloader = "flex";
            var form = new FormData();
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let formalurl = this.ImagePathval;
            let doctype = "image";
            form.append("username", username);
            form.append("accesskey", accesskey);
            form.append("formalurl", formalurl);
            form.append("doctype", doctype);
            form.append("file", this.file);
            this.$store
                .dispatch("uploadfile", form)
                .then(resp => {
                    this.ImagePathval = resp;
                    this.uploadedimage = resp;
                    this.onloader = "none";
                    this.ShowAlertSuccess('Uploaded Successfully', '');
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        editBookCategoryItem(item) {
            this.onloader = "flex";
            this.Idval = item.Id;
            this.CategoryNameval = item.CategoryName;
            this.CategoryCodeval = item.CategoryCode;
            this.process = "U";
            this.onloader = "none";
        },
        submitBookCategoryForm() {
            let Id = this.Idval;
            let CategoryName = this.CategoryNameval;
            let CategoryCode = this.CategoryCodeval;
            let processop = this.process;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let userdata = {
                Id,
                CategoryName,
                CategoryCode,
                processop,
                username,
                accesskey
            };
            this.onloader = "flex";
            this.$store
                .dispatch("libraryCategory/ProcessLibraryCategory", userdata)
                .then(resp => {
                    this.LibraryCategoryItems = resp;
                    this.CategoryNameval = "";
                    this.CategoryCodeval = "";
                    this.process = "N";
                    this.onloader = "none";
                    this.ShowAlertSuccess('Submitted Successfully', '');
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },

    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
        if (this.accessDetails.isSchoolStaff == false) {
            this.$store.dispatch('auth/Logout')
            this.$router.push('/login')
        }
    }
};
</script>

<style></style>
